<template>
  <div class="auth-page register-page">
    <!-- Logo positioned absolutely -->
    <div class="logo-container">
      <img src="../assets/images/makeping-logo1.svg" alt="MakePing" class="logo" />
    </div>

    <!-- Main Content Centered -->
    <div class="content-wrapper">
      <!-- Title -->
      <h1 class="page-title">
        Create Your <span class="text-orange">Free Account</span>
      </h1>
      
      <!-- Form Card -->
      <div class="auth-card">
        <form @submit.prevent="Register()">
          <!-- Full Name -->
          <div class="form-group">
            <label for="fullName" class="form-label">Full Name</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/user-icon.svg" class="input-icon" alt="user" />
              <input
                v-model="input.username"
                :state="validateFullName"
                type="text"
                id="fullName"
                class="form-control custom-input"
                placeholder="Enter your name"
                maxlength="50"
                required
              />
            </div>
            <b-form-invalid-feedback :state="validateFullName">{{ fullname_err_text }}</b-form-invalid-feedback>
          </div>

          <!-- Email -->
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/mail-icon.svg" class="input-icon" alt="email" />
              <input
                v-model="input.email"
                type="email"
                id="email"
                class="form-control custom-input"
                placeholder="Enter your email"
                maxlength="50"
                autocomplete="email"
                required
              />
            </div>
          </div>

          <!-- Create Password -->
          <div class="form-group">
            <label for="password" class="form-label">
              Create Password
              <small class="text-muted">(min. 6 character)</small>
            </label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
              <input
                v-model="input.password"
                :type="showPassword ? 'text' : 'password'"
                id="newpassword"
                class="form-control custom-input"
                :placeholder="input.password ? '••••••••' : 'Enter Password'"
                maxlength="30"
                autocomplete="new-password"
                :state="validatePassword"
                required
              />
              <img 
                v-if="showPassword && input.password"
                src="../assets/fonts/feather/eye.svg"
                class="toggle-password"
                @click="togglePassword('newpassword')"
                title="hide password"
                alt="hide password"
              />
              <img 
                v-else-if="!showPassword && input.password"
                src="../assets/images/icons/eye-closed.svg"
                class="toggle-password"
                @click="togglePassword('newpassword')"
                title="show password"
                alt="show password"
              />
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="form-group">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
              <input
                v-model="verify_password"
                :type="showReEnterdPassword ? 'text' : 'password'"
                id="reenterpassword"
                class="form-control custom-input"
                :placeholder="verify_password ? '••••••••' : 'Confirm Password'"
                maxlength="30"
                autocomplete="new-password"
                :state="validatePassword"
                required
              />
              <img 
                v-if="showReEnterdPassword && verify_password"
                src="../assets/fonts/feather/eye.svg"
                class="toggle-password"
                @click="toggleReEnterdPassword('reenterpassword')"
                title="hide password"
                alt="hide password"
              />
              <img 
                v-else-if="!showReEnterdPassword && verify_password"
                src="../assets/images/icons/eye-closed.svg"
                class="toggle-password"
                @click="toggleReEnterdPassword('reenterpassword')"
                title="show password"
                alt="show password"
              />
            </div>
          </div>

          <!-- Register Button -->
          <button type="submit" class="btn btn-auth-primary">
            Register now
          </button>

          <!-- Google Sign Up -->
          <button type="button" class="btn btn-google" @click="OngoogleLogin()">
            <img src="../assets/images/google_logo.webp" alt="Google" class="google-icon" />
            Sign up with Google
          </button>

          <!-- Divider -->
          <hr class="form-divider" />

          <!-- Already have account -->
          <div class="login-link-container">
            <router-link to="/auth/login" class="auth-link">
              Already have an account?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UserController from "../../services/userController"
import Config from "../../services/config"
import Userauth from "../auth/js/index";
import { userEvents } from '@/plugins/posthog-events';
// import TagManager from "../../services/tagmanager"
    export default {
        name: 'signUp',
        data(){
          return{
            showPassword:false,
            showReEnterdPassword:false,
            fullname_err_text:'',
            verify_password:'',
            input:{email:'',username:'',password:'',source:'',clickid:'',refererid:''},
            googleLogin:''
          }
        },
        mounted(){
          if(this.$route.query.email){
            this.input.email = this.$route.query.email
          }
          if(this.$route.query.source){
            this.input.source = this.$route.query.source
            this.$root.$data.source = this.input.source
              // TagManager.callTagManager(this.input.source)
              // TagManager.SendConversion(this.input.source)
          }
          if(this.$route.query.refererid){
            this.input.refererid = this.$route.query.refererid
          }
          if(this.$route.query.clickid){
            this.input.clickid = this.$route.query.clickid
            this.$root.$data.clickid = this.$route.query.clickid}
            if(this.$root.$data.clickid){this.input.clickid = this.$root.$data.clickid}
            if(this.$root.$data.source){this.input.source = this.$root.$data.source}
            this.googleLogin = Config.googleLogin+'?source='+this.input.source+'&clickid='+this.input.clickid+'&refererid='+this.input.refererid
            if(Userauth.isAuthenticated() && Userauth.checAlive()){
                let user  = JSON.parse(window.localStorage.getItem('userinfo'))
                if(user.role == 'manager'){
                    this.$router.replace("/manager/users");
                }
                else{
                    this.$router.replace("/app/dashboard");
                }
                this.$toasted.show('Successfully Logged In to - '+user.email, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            }
          },
        computed:{
          validateFullName() {
            var fullName = this.input.username
            const regex = /^[a-zA-Z0-9 ]+$/; // Alphanumeric and space characters only
            const maxLength = 50; // Maximum length of the full name field
            if (fullName.length >= maxLength) {
              this.fullname_err_text = "Full name cannot exceed "+maxLength+" characters"
              return false;
            }
            else if (!regex.test(fullName) && fullName != '') {
              this.input.username = ''
              this.fullname_err_text = "Full name can only contain alphanumeric characters and spaces";
              return false;
            }
            return true;
          },
          validatePassword(){
            if(this.input.password && this.input.password.length >=30){
                this.$toasted.show('Characters Limit Exceeded!', {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
            }
        }
        },
        methods: {
          OngoogleLogin(){
              window.location.href = this.googleLogin
          },
        async Register(){
            if(this.validate()){
                let response= await UserController.signup(this.input,this.input.source,this.input.clickid,this.input.refererid)
                if(response.result){
                    // Track user signup in PostHog
                    userEvents.signedUp('email', response.message || this.input);
                  if(!response.message.isactive){

                    this.$router.replace({ path: "/auth/verification", query: { from: "register" } });
                      // this.$toasted.show('Your Account is not Activated. Sending Verification code.', {theme: 'outline',position: "bottom-center", type: 'error', duration: 4000});
                    }
                }
                else{
                    this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                }
            }
          },
          validateEmail(email) {
            const regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
            return regex.test(email);
          },
          validate(){
            
            if(this.validateEmail(this.input.email)){
              if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.input.email)) {
              if(this.input.email == '' && this.input.password == ''){
                this.$toasted.show("Please enter a valid email address and password", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false;
              }
              if(this.input.email && this.input.password.length < 6){
                this.$toasted.show("password length should be more then 6 character", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false;
              }
              if (/\s/.test(this.input.password)) {
                this.$toasted.show("Password should not contain spaces", {
                  theme: 'outline',
                  position: "bottom-center",
                  type: 'error',
                  duration: 2000
                });
                return false;
              }
              if(this.input.password != this.verify_password){
                this.input.password = ''
                this.verify_password=''
                this.$toasted.show("Password not match", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
                return false;
              }
                return true;
            }
          }else{
              this.$toasted.show("Invalid Email", {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
              return false;
            }
        },
        togglePassword(id){
          const password = document.getElementById(id);
          this.showPassword = this.showPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        },
        toggleReEnterdPassword(id){
          const password = document.getElementById(id);
          this.showReEnterdPassword = this.showReEnterdPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        }
      }
    }
</script>

<style>
@import '../assets/css/auth.css';
</style>

<style scoped>
/* Register page specific styles */
.login-link-container {
  text-align: center;
  margin-top: 0;
}
</style>